// B-86 — the frame the sign-in and the sign-up share: the Cierres redesign's look (Red Hat Display
// + Lora, its neutrals, borders, card shadow and dark primary) with Mantis's own logo, never a
// client's.
//
// Every client of the business front signs in here — not only the Cierres ones — so the copy is
// the platform's, never one product line's.
//
// Two columns from `lg` up, mirrored: on the left a brand panel in the primary's dark — an inset,
// rounded card on the light page rather than a hard split down the middle — its content
// centred both ways in a column as wide as the form's card — the logo, a Lora headline, one line of
// subtitle, a hairline, and "Acceso cifrado y por roles" beside "Powered by" with the Mantis mark —
// and on the right the form, centred the same way. A faint dot grid fills the dark side instead of
// more copy. On a phone the panel is hidden and the logo sits above the form, "Powered by" below.
import { ShieldCheck } from "lucide-react";

import { isSandy } from "../config";
import mantisLogo from "../Assets/img/mantisBlackLogo.png";
import sandyLogo from "../Assets/img/sandyBlackLogo.png";
import "../MantisBusiness/Sections/Cierres/styles/brinksTheme.css";

const LOGO = isSandy ? sandyLogo : mantisLogo;
const MARCA = isSandy ? "Sandy" : "Mantis";

// A dot every 22px, barely there: texture for the dark panel, not decoration to read.
const TRAMA = {
  backgroundImage:
    "radial-gradient(rgba(255,255,255,0.07) 1px, transparent 1px)",
  backgroundSize: "22px 22px",
};

export function PoweredBy({ className = "", claro = false }) {
  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <span
        className={`text-[10.5px] font-medium uppercase tracking-[0.08em] ${
          claro ? "text-white/60" : "text-brinks-muted-foreground"
        }`}
      >
        Powered by
      </span>
      <img
        src="/mantisCircle.png"
        alt="Mantis"
        className={`h-3.5 w-auto object-contain ${claro ? "invert" : "opacity-80"}`}
      />
    </div>
  );
}

export function AuthLayout({ titulo, subtitulo, children }) {
  return (
    <div className="brinks-scope font-redhat grid min-h-screen bg-background lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]">
      <aside
        className="relative m-3 hidden items-center justify-center overflow-hidden rounded-[20px] bg-primary px-10 py-10 text-primary-foreground shadow-brinks-card lg:flex"
        style={TRAMA}
      >
        <div className="flex w-full max-w-[420px] flex-col items-center text-center">
          <img
            src={LOGO}
            alt={MARCA}
            className="h-10 w-auto object-contain brightness-0 invert"
          />
          <h2 className="mt-10 font-lora text-[32px] font-semibold leading-[1.2] text-white xl:text-[36px]">
            {titulo}
          </h2>
          {subtitulo ? (
            <p className="mt-4 text-[14.5px] leading-relaxed text-white/70">
              {subtitulo}
            </p>
          ) : null}
          <div className="mt-10 flex w-full items-center justify-center gap-6 border-t border-white/15 pt-5 text-[12px] text-white/60">
            <span className="flex items-center gap-1.5">
              <ShieldCheck className="h-3.5 w-3.5" /> Acceso cifrado y por roles
            </span>
            <span aria-hidden="true" className="h-3 w-px bg-white/20" />
            <PoweredBy claro />
          </div>
        </div>
      </aside>

      <main className="flex min-h-screen flex-col items-center justify-center px-4 py-10 sm:px-8">
        <img
          src={LOGO}
          alt={MARCA}
          className="mb-8 h-9 w-auto object-contain lg:hidden"
        />
        <div className="w-full max-w-[420px]">{children}</div>
        <PoweredBy className="mt-10 lg:hidden" />
      </main>
    </div>
  );
}

export default AuthLayout;
